import React from 'react';
import styles from './FiltersGroup.module.css';

interface FiltersGroupProps {
  className?: string;
  children: React.ReactNode;
}

const FiltersGroup: React.FC<FiltersGroupProps> = ({ className = '', children }) => {
  const cls = [styles['filters-group'], className].filter(Boolean).join(' ');
  return <div className={cls}>{children}</div>;
};

export default FiltersGroup;
